// @flow

import type {SearchResult} from 'docs/data';

const SEARCH_RESULTS_LOADED = 'SEARCH_RESULTS_LOADED';
const SEARCH_RESULTS_LOADING = 'SEARCH_RESULTS_LOADING';

export type SearchResultsLoadingEvent = {|
  type: typeof SEARCH_RESULTS_LOADING,
  payload: {query: string},
|};

export const searchResultsLoading = (
  query: string,
): SearchResultsLoadingEvent => ({
  type: SEARCH_RESULTS_LOADING,
  payload: {query},
});

export type SearchResultsLoadedEvent = {|
  type: typeof SEARCH_RESULTS_LOADED,
  payload: {results: Array<SearchResult>},
|};

export const searchResultsLoaded = (
  results: Array<SearchResult>,
): SearchResultsLoadedEvent => ({
  type: SEARCH_RESULTS_LOADED,
  payload: {results},
});

export type SearchEvent = SearchResultsLoadingEvent | SearchResultsLoadedEvent;

export type SearchReducerState = {|
  isLoading: boolean,
  query: string,
  results: Array<SearchResult>,
|};

export const SearchReducer = (
  state: SearchReducerState,
  event: SearchEvent,
) => {
  switch (event.type) {
    case SEARCH_RESULTS_LOADING:
      return {
        ...state,
        query: event.payload.query,
        isLoading: true,
      };
    case SEARCH_RESULTS_LOADED:
      return {
        ...state,
        results: event.payload.results,
        isLoading: false,
      };
    default:
      throw new Error(`Unknown search event ${event.type}`);
  }
};
